import svg4everybody from 'svg4everybody';
import EnhancerApp from '../enhancer-app';
import '../enhancers/article-body';
import '../enhancers/drawer';
import '../enhancers/equal-height';
import '../enhancers/collapse-button';
import '../enhancers/filter';
import '../enhancers/load-more-button';
import '../enhancers/progress-button';
import '../enhancers/herobagde-spacer';
import '../enhancers/dismissable-alert';
import '../enhancers/form';
import '../enhancers/quiz';

import * as cookie from '../utils/cookie';
import * as queryString from '../utils/query-string';
import * as utils from '../utils/utils';

// HTML has loaded
document.addEventListener('DOMContentLoaded', () => {

    svg4everybody();

    EnhancerApp.start();

}, false);

// Images, etc has loaded
window.addEventListener('load', () => {

    // Add code here

});

(function ($) {
    $.validator.unobtrusive.adapters.addBool("checkboxrequired", "required");
}(jQuery));

